<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
// import Button from "@/components/c-button";


import { invoiceService } from "../../../../services/managements/invoices/invoice.service";
// import { paymentService } from "../../../../services/managements/invoices/payment.service";
// import { servicehelpers } from "../../../../services/servicehelpers";
import moment from 'moment'

// import i18n from "../../../../i18n";
// import Loading from "@/components/c-loading";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Payment Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    // Button
    
    // Loading, 
  },
  data() {
    return {
      fetchingStats: true,
      tryingToSubmit: false,
      data: {},
      discountTypeData: {},

      dataCustomerId: 0,
      dataPropertyId: 0,
      dataInvoiceId: 0,
      dataTotalAmount: 0,
      dataDiscount: 0,
      dataPayableAmount: 0,
      dataReceiveAmount: 0,
      dataDebtAmount: 0,
      dataDueAmount: 0,
      dataCashAmount: 0,
      dataBankAmount: 0,
      dataChequeAmount: 0,
      dataDepositAmount: 0,
      dataNotation: '',
      dataDiscountText: '%',
      dataDiscountType: 1,
      dataCreatedBy: JSON.parse(localStorage.getItem('user'))
    };
  },
  mounted() {
    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    }
  
  },

  methods: {
    loadingData: function(id){
      this.fetchingStats = true;
      invoiceService.getOne(id)
        .then(response => {
          if(id != 0){
            console.log(response)
            this.data = response.data;
            this.dataInvoiceId = this.data.invoice.id;
            this.dataPropertyId = this.data.invoice.property_id;
            this.dataCustomerId = this.data.customer ? this.data.customer.deposit_amount.id: 0;
            this.dataTotalAmount = (this.total(this.data.invoice_detail.service, 'total_price') + this.total(this.data.invoice_detail.utility, 'total_price'));
            this.dataPayableAmount = (this.total(this.data.invoice_detail.service, 'total_price') + this.total(this.data.invoice_detail.utility, 'total_price'));
            this.dataDepositAmount = this.data.customer ? this.data.customer.deposit_amount: 0;
          }
        }); 
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    
    formatCurrency: function(value) {
      if(value == 0 ){
        return '0.00';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },
    print() {
      window.print();
    },
    total(data, column_name) {
      return data.reduce(function (sum,item) {
         return sum + item[column_name];
      }, 0);
    }
  },
};
</script>

<template>
  <Layout>
    <div>
      <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('invoice.text')" />
    </div>

    <Loading :loaded="fetchingStats" />
   
    <div>
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm p-3 me-1 " id="print-area">
                <!-- logo header  -->
                <section class="mb-3">
                  <table width="" class="content-general bottom m-auto">
                    <tr>
                      <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                      <td>
                        <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                        <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                        <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                        <p class="khs h8">ទូរស័ព្ទលេខៈ 015 55 40 77 | 078 55 40 77 Email: account@h-residence.net</p>
                      </td>
                    </tr>
                  </table>
                </section>
                <div class="row mb-3">
                  <div class="col">
                    <p class="khb h3 text-center"><u>{{$t('invoice.text')}}</u></p>
                  </div>
                </div>
                <!-- invoice primary info  -->
                <div class="row " v-if="data.invoice">
                  <div class="col">
                    <div class="row">
                      <div class="col-4">
                        <p class="khs h5">{{$t('invoice.number')}}</p>
                        <p class="khs h5">{{$t('manage.room-no')}} </p>
                        <p class="khs h5"> {{$t('invoice.date')}}</p>

                      </div>
                      <div class="col">
                        <p class="khs h5 fw-bold text-primary">: {{data.invoice.code}}</p>
                        <p class="khs h5 fw-bold text-primary">: {{data.room_no}}</p>

                        <p class="khs h5">: {{this.dateFormat(data.invoice.invoice_date)}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="row">
                      <div class="col-4">
                        <p class="khs h5"> {{$t('general.customer_name')}}</p>
                        <p class="khs h5"> {{$t('customer.phone-no')}}</p>
                        <p class="khs h5"> {{$t('customer.email')}}</p>
                      </div>
                      <div class="col">
                        <p class="khs h5">: {{data.customer ? data.customer.name : '' }}</p>
                        <p class="khs h5">: {{data.customer ? data.customer.phone_no_1 : ''}}{{data.customer ? (data.customer.phone_no_2?'/'+data.customer.phone_no_2:'') :'' }}</p>
                        <p class="khs h5">: {{data.customer ? data.customer.email : ''}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- invoice body  -->
                <div class="row">
                  <div class="col-sm">
                    <table class="table table-bordered mb-3">
                      
                        <tr class="thead">
                          <th width="10">{{$t('general.number')}}</th>
                          <th>{{$t('manage.service.text')}}</th>
                          <th width="20">{{$t('invoice.quantity')}}</th>
                          <th>{{$t('invoice.price')}}</th>
                          <th>{{$t('invoice.total')}}</th>
                        </tr>
                      
                      <tbody v-if="this.data.invoice_detail">
                        <tr v-for="(data, index) in data.invoice_detail.service" :key="index">
                          <td>{{index + 1}}</td>
                          <td>{{data.name}}</td>
                          <td>{{data.quantity}}</td>
                          <td>{{formatCurrency(data.price)}}</td>
                          <td>{{formatCurrency(data.total_price)}}</td>
                        </tr>
                        
                      </tbody>
                      
                        <tr v-if="this.data.invoice_detail" class="tfoot">
                          <td colspan="4" class="khs fw-bolder text-end">
                            {{$t('invoice.amount')}}
                          </td>
                          <td>{{formatCurrency(total(data.invoice_detail.service, 'total_price'))}}</td>
                        </tr>
                      
                    </table>

                    <table class="table table-bordered" v-if="this.data.invoice_detail.utility.length">
                      
                        <tr class="thead">
                          <th colspan="2">{{$t('manage.start-date')}} - {{$t('manage.end-date')}}</th>
                          <th >{{$t('manage.utility.old-record')}}</th>
                          <th >{{$t('manage.utility.new-record')}}</th>
                          <th >{{$t('manage.utility.used')}}</th>
                          <th>{{$t('invoice.price')}}</th>
                          <th>{{$t('invoice.total')}}</th>
                        </tr>
                      
                      <tbody v-if="data">
                        <tr v-for="(data, index) in data.invoice_detail.utility" :key="index">
                          <td>{{index + 1}}</td>
                          <td>{{data.name}}</td>
                          <td>{{data.old_record}}</td>
                          <td>{{data.new_record}}</td>
                          <td>{{data.quantity}}</td>
                          <td>{{formatCurrency(data.price)}}</td>
                          <td>{{formatCurrency(data.total_price)}}</td>
                        </tr>
                      </tbody>
                      
                        <tr class="tfoot">
                          <td colspan="6" class="khs fw-bolder text-end">
                            {{$t('invoice.amount')}}
                          </td>
                          <td>{{formatCurrency(total(data.invoice_detail.utility, 'total_price'))}}</td>
                        </tr>
                        <tr class="tfoot">
                           <td colspan="6" class="khs fw-bolder text-end">
                             {{$t('payment.pay-amount')}}
                           </td>
                          <td>{{formatCurrency(total(data.invoice_detail.service, 'total_price') + total(data.invoice_detail.utility, 'total_price'))}}</td>
                        </tr>
                    </table>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div> 
  </Layout>
</template>